module.exports = false;


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0